import React from 'react';
import { styled } from '../../../stitches.config';

import FootballScores from "../../FootballScores"

export default props => {
    return (
        <Section>
            <div className="container">
                <FootballScores data={window.APP_SETTINGS.sport_results} />
            </div>
        </Section>
    );
}


const Section = styled("div",{
    width: "100%"
});